import React, { useEffect, useState } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import axios from "axios";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import ByCounty from "../ByCounty/ByCounty";
import ByCommodity from "../ByCommodity/ByCommodity";
import DashboardTables from "../DashboardTables/DashboardTables";
import DashboardNotes from "../DashboardNotes/DashboardNotes";
import PrintButton from '../PrintButton/PrintButton';

export default function RegionOverview(props) {
  const { regionName, regionKey } = props;

  const [regionData, setRegionData] = useState();
  const [regionDataLoaded, setRegionDataLoaded] = useState(false);
  const [commodityImports, setCommodityImports] = useState();
  const [commodityExports, setCommodityExports] = useState();
  const [commodityExportsLoaded, setCommodityExportsLoaded] = useState();
  const [commodityImportsLoaded, setCommodityImportsLoaded] = useState(false);
  const [totalCounties, setTotalCounties] = useState();
  const [totalCommodities, setTotalCommodities] = useState();
    useEffect(() => {
    (() => {
      axios
        .get(`/wp-json/region/v1?url_key=${regionKey}`)
        .then((res) => res.data)
        .then((data) => {
          setRegionData(data[0]);
          setRegionDataLoaded(true);
          console.log(data);
        })
        .catch((e) => console.log(e));
    })();
    (() => {
      axios
        .get(
          `/wp-json/commoditybyregion/v1?url_key=${regionKey}&sort_by=ImportSTONS&sort_dir=DESC&page=1&limit=5`
        )
        .then((res) => res.data)
        .then((data) => {
          let arr = [];
          const top5 = Object.entries(data)
            .slice(0, 5)
            .map((entry) => entry[1]);
          if (top5) {
            top5.forEach((value) => {
              arr.push({
                name: value.CommodityName,
                importSTONS: value.ImportSTONS,
              });
            });
          }
          setCommodityImports(arr);
          setCommodityImportsLoaded(true);
        })
        .catch((e) => console.log(e));
    })();
    (() => {
      axios
        .get(
          `/wp-json/commoditybyregion/v1?url_key=${regionKey}&sort_by=ExportSTONS&sort_dir=DESC&page=1&limit=5`
        )
        .then((res) => res.data)
        .then((data) => {
          let arr = [];
          const top5 = Object.entries(data)
            .slice(0, 5)
            .map((entry) => entry[1]);
          if (top5) {
            top5.forEach((value) => {
              arr.push({
                name: value.CommodityName,
                exportSTONS: value.ExportSTONS,
              });
            });
          }
          setCommodityExports(arr);
          setCommodityExportsLoaded(true);
        })
        .catch((e) => console.log(e));
    })();
  }, [regionKey]);

   

  return (
    <>
      <BreadCrumb
        isRegion={true}
        regionName={regionName}
        regionKey={regionKey}
      />

      <h1>{regionName}</h1>

      <Tabs>
        <TabList>
          <Tab>Overview</Tab>
          <Tab>By County {totalCounties ? `(${totalCounties})` : null}</Tab>
          <Tab>
            By Commodity {totalCommodities ? `(${totalCommodities})` : null}
          </Tab>
        </TabList>
        <TabPanel>
          <PrintButton />
          <DashboardTables
            apiData={regionData}
            apiLoaded={regionDataLoaded}
            importData={commodityImports}
            exportData={commodityExports}
            importLoaded={commodityImportsLoaded}
            exportLoaded={commodityExportsLoaded}
            showCharts={true}
          />
        </TabPanel>
        <TabPanel>
          <ByCounty
            regionKey={regionKey}
            toChild={totalCounties}
            sendToParent={setTotalCounties}
          />
        </TabPanel>
        <TabPanel>
          <ByCommodity
            regionKey={regionKey}
            toChild={totalCommodities}
            sendToParent={setTotalCommodities}
          />
        </TabPanel>
      </Tabs>
      <DashboardNotes />
    </>
  );
}
